import { HeaderText as SharedHeaderText } from '../../components/atomic/text/header_text/HeaderText';
import headerTextImg from '../texts/header_text.png';
import './HeaderText.css';

export function HeaderText() {
  return (
    <SharedHeaderText
      className="success-delivery-header-text"
      src={headerTextImg}
      alt="Доставка успешна!"
    />
  );
}
